import { gql } from '@apollo/client';

export const RECORD_INSTORE_ORDER = gql`
  mutation RecordInstoreOrder($input: RecordInstoreOrderInput!) {
    recordInstoreOrder(input: $input) {
      success
      message
      errors {
        code
        field
        message
      }
    }
  }
`;

export const RECORD_INVENTORY_ADJUSTMENT = gql`
  mutation RecordInventoryAdjustment($input: RecordInventoryAdjustmentInput!) {
    recordInventoryAdjustment(input: $input) {
      success
      message
    }
  }
`;

export const GET_INVENTORY_ADJUSTMENT_REASONS = gql`
  query GetInventoryAdjustmentReasons($languageCode: String) {
    getInventoryAdjustmentReasonEnum(languageCode: $languageCode) {
      value
      displayValue
      isSupported
    }
  }
`;

/**
 * Generate an idempotency key for in-store order / inventory mutations so a
 * retried request is not double-counted by the backend.
 */
export function generateClientRequestId() {
  const t = Date.now().toString(36);
  const r1 = Math.random().toString(36).slice(2, 10);
  const r2 = Math.random().toString(36).slice(2, 10);
  return `req_${t}_${r1}${r2}`;
}
